import React, { useState } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import BottomNav from '../component/BottomNav';
import { API_URL } from '../common/constant';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post(`${API_URL}/api/admin/login`, {
                username,
                password,
            });
            toast.success(response.data.message);
            localStorage.setItem('token', response.data.token);
            navigate('/requirementsList');
        } catch (error) {
            if (error.response && error.response.status === 401) {
                toast.error('Invalid username or password!');
            } else {
                toast.error('An error occurred, please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-blue-50 to-indigo-100 px-4 sm:px-0">
                <div className="bg-white shadow-2xl rounded-lg p-6 sm:p-8 max-w-md w-full sm:my-4" >
                    <h2 className="text-2xl sm:text-3xl font-semibold text-center text-black mb-6 sm:mb-8" style={{ color: '#54BD95' }}>Admin Login</h2>
                    <form onSubmit={handleLogin}>
                        <div className="mb-4 sm:mb-5">
                            <label htmlFor="username" className="block text-sm font-semibold text-gray-600">Username</label>
                            <input
                                type="text"
                                id="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className="mt-1 sm:mt-2 w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                                required
                            />
                        </div>
                        <div className="mb-6 sm:mb-8">
                            <label htmlFor="password" className="block text-sm font-semibold text-gray-600">Password</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="mt-1 sm:mt-2 w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            className={`w-full bg-black text-white font-semibold py-2 rounded-lg transition-transform duration-300 ${loading ? 'opacity-70 cursor-not-allowed' : 'hover:bg-gray-800 hover:scale-105'}`}
                            disabled={loading}
                            style={{ backgroundColor: '#54BD95' }}
                        >
                            {loading ? (
                                <span className="flex justify-center items-center">
                                    <svg className="animate-spin h-5 w-5 mr-3 text-white" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                        <path className="opacity-75" fill="currentColor" d="M4 12c0-1.07.137-2.09.394-3.08L2.345 7.34A11.966 11.966 0 0 0 0 12h4zm8-10a10.002 10.002 0 0 1 7.76 3.658l-1.66 1.05A8.003 8.003 0 0 0 12 2zm8 8c0 1.07-.137 2.09-.394 3.08L21.655 16.66A11.966 11.966 0 0 0 24 12h-4zm-8 10a10.002 10.002 0 0 1-7.76-3.658l1.66-1.05A8.003 8.003 0 0 0 12 22zm-8-8c0-1.07.137-2.09.394-3.08L2.345 7.34A11.966 11.966 0 0 0 0 12h4z" />
                                    </svg>
                                    Logging in...
                                </span>
                            ) : 'Login'}
                        </button>
                    </form>
                    <ToastContainer position="top-right" />
                </div>
            </div>
            <BottomNav />
        </>
    );
};

export default Login;
